// // Services.js
// import React, { useEffect } from 'react';
// import './Services.css';
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import {
//   FaMobileAlt,
//   FaCloud,
//   FaCogs,
//   FaCode,
//   FaLaptopCode,
//   FaRobot,
//   FaClipboardCheck,
//   FaShieldAlt,
//   FaSyncAlt,
// } from 'react-icons/fa';


// import { FaJava } from "react-icons/fa";
// // then use { name: "Java", icon: <FaJava /> }

// import {
//   SiReact,
//   SiNextdotjs,
//   SiNodedotjs,
//   SiExpress,
//   SiPython,
//   SiFastapi,
//   SiMongodb,
//   SiPostgresql,
//   SiAmazonwebservices, // ✅ instead of SiAmazonaws
//   // SiJava,              // ✅ if you updated; otherwise swap to SiOpenjdk
//   SiFirebase,
//   // If NOT updating react-icons, also import this:
//   // SiOpenjdk,
// } from "react-icons/si";

// // Fallback if you cannot update:
// // import { SiOpenjdk as SiJava } from "react-icons/si";


// const services = [
//   {
//     title: 'Web App Development',
//     icon: <FaLaptopCode />,
//     description:
//       'Custom, responsive, and high-performing web applications using modern frameworks.',
//   },
//   {
//     title: 'Mobile App Development',
//     icon: <FaMobileAlt />,
//     description:
//       'iOS & Android apps with smooth performance, offline support, and delightful UX.',
//   },
//   {
//     title: 'Cloud Services',
//     icon: <FaCloud />,
//     description:
//       'Secure cloud hosting, DevOps, IaC, and CI/CD with AWS, Azure, and GCP.',
//   },
//   {
//     title: 'AI & Automation',
//     icon: <FaRobot />,
//     description:
//       'ML models, chatbots, and workflow automation to accelerate your business.',
//   },
//   {
//     title: 'UI/UX Design',
//     icon: <FaCogs />,
//     description:
//       'User-centric interfaces, design systems, and accessibility baked in.',
//   },
//   {
//     title: 'Software Testing',
//     icon: <FaCode />,
//     description:
//       'Automated + manual QA for reliability, performance, and security.',
//   },
// ];

// const industries = [
//   'Matchmaking Platform',
//   'Healthcare',
//   'E-commerce',
// ];

// const stack = [
//   { name: "React.js",     icon: <SiReact /> },
//   { name: "Next.js",      icon: <SiNextdotjs /> },
//   { name: "Node.js",      icon: <SiNodedotjs /> },
//   { name: "Express",      icon: <SiExpress /> },
//   { name: "Python",       icon: <SiPython /> },
//   { name: "FastAPI",      icon: <SiFastapi /> },
//   { name: "MongoDB",      icon: <SiMongodb /> },
//   { name: "PostgreSQL",   icon: <SiPostgresql /> },
//   { name: "React Native", icon: <SiReact /> },
//   { name: "AWS",          icon: <SiAmazonwebservices /> }, // ✅
//   { name: "Java",         icon: <FaJava /> },               // ✅ or alias to SiOpenjdk
//   { name: "Firebase",     icon: <SiFirebase /> },
// ];



// const timeline = [
//   {
//     icon: <FaClipboardCheck />,
//     title: 'Discover',
//     desc: 'Workshops to align goals, users, scope, and timelines.',
//   },
//   {
//     icon: <FaCogs />,
//     title: 'Design',
//     desc: 'Wireframes, clickable prototypes, and design systems.',
//   },
//   {
//     icon: <FaSyncAlt />,
//     title: 'Build',
//     desc: 'Agile sprints with CI/CD, code review, and observability.',
//   },
//   {
//     icon: <FaShieldAlt />,
//     title: 'Launch',
//     desc: 'Hardening, security checks, and zero-downtime deploys.',
//   },
// ];

// const Services = () => {
//   useEffect(() => {
//     AOS.init({ duration: 900, once: true, easing: 'ease-out' });
//   }, []);

//   return (
//     <div className="services-page">
//       {/* Page Hero */}
//       <header className="services-hero" data-aos="fade-up">
//         <div className="blob blob-l" aria-hidden />
//         <div className="blob blob-r" aria-hidden />
//         <h2 className="services-title">Our Services</h2>
//         <p className="services-subtitle">
//           Building future-ready Solutions with engineering rigor and product mindset.
//         </p>
//       </header>

//       {/* Services Grid */}
//       <div className="services-grid container">
//         {services.map((service, i) => (
//           <div
//             className="service-card"
//             key={service.title}
//             data-aos="fade-up"
//             data-aos-delay={i * 80}
//           >
//             <div className="service-icon">{service.icon}</div>
//             <h4>{service.title}</h4>
//             <p>{service.description}</p>
//           </div>
//         ))}
//       </div>

//       {/* What Sets Us Apart */}
//       <section className="unique-section">
//         <h2 className="unique-title" data-aos="fade-up">What Sets Us Apart?</h2>
//         <p className="unique-subtitle" data-aos="fade-up">
//           We blend creativity, performance, and security to craft software that scales with your business.
//         </p>

//         <div className="unique-features">
//           <div className="unique-box" data-aos="zoom-in-up">
//             <h3>Outcome-Driven</h3>
//             <p>We map features to measurable business goals and user value.</p>
//           </div>
//           <div className="unique-box" data-aos="zoom-in-up" data-aos-delay="120">
//             <h3>Engineering Excellence</h3>
//             <p>Clean architecture, testing discipline, and observability.</p>
//           </div>
//           <div className="unique-box" data-aos="zoom-in-up" data-aos-delay="240">
//             <h3>Secure by Design</h3>
//             <p>Threat modeling, secret hygiene, and least-privilege access.</p>
//           </div>
//         </div>

// <h4 className="stack-heading">Tech Stack We Work With</h4>
// <div className="stack-logos">
//   {stack.map((t, i) => (
//     <span className="stack-tag" key={t.name} style={{ animationDelay: `${i * 0.12}s` }}>
//       <span className="stack-ico" aria-hidden>{t.icon}</span>
//       {t.name}
//     </span>
//   ))}
// </div>


//       </section>

//       {/* Process Timeline */}
//       <section className="timeline-section">
//         <div className="container">
//           <h2 className="timeline-title" data-aos="fade-up">How We Deliver</h2>
//           <ol className="timeline">
//             {timeline.map((step, i) => (
//               <li className="timeline-item" key={step.title} data-aos="fade-up" data-aos-delay={i * 120}>
//                 <span className="timeline-badge">{step.icon}</span>
//                 <div className="timeline-content">
//                   <h3>{step.title}</h3>
//                   <p>{step.desc}</p>
//                 </div>
//               </li>
//             ))}
//           </ol>
//         </div>
//       </section>

//       {/* Industries */}
//       <section className="industries-section">
//         <h2 className="industries-title" data-aos="fade-up">Industries We Serve</h2>
//         <p className="industries-subtitle" data-aos="fade-up">
//           Tailored Solutions for domains where reliability and scale matter most.
//         </p>

//         <div className="industries-grid">
//           {industries.map((industry, index) => (
//             <div
//               className="industry-card"
//               key={industry}
//               data-aos="flip-left"
//               data-aos-delay={index * 120}
//             >
//               {industry}
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="cta-section">
//         <h2 className="cta-title" data-aos="zoom-in">Let’s Build Something Great Together</h2>
//         <p className="cta-subtitle" data-aos="zoom-in" data-aos-delay="100">
//           Tell us your goals — we’ll bring the blueprint and the team.
//         </p>
//         <a href="/contact" className="cta-button" data-aos="zoom-in" data-aos-delay="200" aria-label="Contact us">
//           Contact Us
//         </a>
//       </section>
//     </div>
//   );
// };

// export default Services;



// Services.js
import React, { useEffect } from 'react';
import './Services.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
  FaMobileAlt,
  FaCloud,
  FaCogs,
  FaCode,
  FaLaptopCode,
  FaRobot,
  FaClipboardCheck,
  FaShieldAlt,
  FaSyncAlt,
  FaSitemap,      // ✅ Enterprise
  FaMicrochip,    // ✅ IoT
} from 'react-icons/fa';

import { FaJava } from 'react-icons/fa';

import {
  SiReact,
  SiNextdotjs,
  SiNodedotjs,
  SiExpress,
  SiPython,
  SiFastapi,
  SiMongodb,
  SiPostgresql,
  SiAmazonwebservices, // ✅ AWS
  SiFirebase,
} from 'react-icons/si';

const services = [
  {
    title: 'Web App Development',
    icon: <FaLaptopCode />,
    description:
      'Custom, responsive, and high-performing web apps built on modern stacks.',
  },
  {
    title: 'Mobile App Development',
    icon: <FaMobileAlt />,
    description:
      'Native-quality iOS & Android apps with smooth performance and delightful UX.',
  },
  {
    title: 'Cloud Services',
    icon: <FaCloud />,
    description:
      'Secure cloud architectures, DevOps, IaC & CI/CD across AWS, Azure, and GCP.',
  },
  // ✅ new card
  {
    title: 'Enterprise Solutions',
    icon: <FaSitemap />,
    description:
      'Scalable, secure platforms, ERP integrations, and multi-tenant architectures.',
  },
  {
    title: 'AI & Automation',
    icon: <FaRobot />,
    description:
      'ML models, intelligent assistants, and workflow automation that accelerate business.',
  },
  // ✅ new card
  {
    title: 'IoT & Embedded',
    icon: <FaMicrochip />,
    description:
      'Sensor-to-cloud pipelines, device management, and real-time monitoring dashboards.',
  },
  {
    title: 'UI/UX Design',
    icon: <FaCogs />,
    description:
      'User-centric interfaces, design systems, accessibility, and rapid prototyping.',
  },
  {
    title: 'Software Testing',
    icon: <FaCode />,
    description:
      'Automated + manual QA for reliability, performance, security, and compliance.',
  },
];

const industries = ['Matchmaking Platform', 'Healthcare', 'Websites', 'Real Estate', 'Travel & Hospitality'];

const stack = [
  { name: 'React.js', icon: <SiReact /> },
  { name: 'Next.js', icon: <SiNextdotjs /> },
  { name: 'Node.js', icon: <SiNodedotjs /> },
  { name: 'Express', icon: <SiExpress /> },
  { name: 'Python', icon: <SiPython /> },
  { name: 'FastAPI', icon: <SiFastapi /> },
  { name: 'MongoDB', icon: <SiMongodb /> },
  { name: 'PostgreSQL', icon: <SiPostgresql /> },
  { name: 'React Native', icon: <SiReact /> },
  { name: 'AWS', icon: <SiAmazonwebservices /> },
  { name: 'Java', icon: <FaJava /> },
  { name: 'Firebase', icon: <SiFirebase /> },
];

const timeline = [
  {
    icon: <FaClipboardCheck />,
    title: 'Discover',
    desc: 'Workshops to align goals, users, scope, success metrics, and timelines.',
  },
  {
    icon: <FaCogs />,
    title: 'Design',
    desc: 'Wireframes, clickable prototypes, and design systems your team can scale.',
  },
  {
    icon: <FaSyncAlt />,
    title: 'Build',
    desc: 'Agile sprints with CI/CD, code review, and deep observability.',
  },
  {
    icon: <FaShieldAlt />,
    title: 'Launch',
    desc: 'Hardening, security checks, performance tuning, and zero-downtime deploys.',
  },
];

const Services = () => {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, easing: 'ease-out' });
  }, []);

  return (
    <div className="services-page">
      {/* Page Hero */}
      <header className="services-hero" data-aos="fade-up">
        <div className="blob blob-l" aria-hidden />
        <div className="blob blob-r" aria-hidden />
        <h2 className="services-title">Our Services</h2>
        <p className="services-subtitle">
          We build reliable, scalable software with an engineering-first mindset—designed for
          real users and real business outcomes.
        </p>
      </header>

      {/* Services Grid */}
      <div className="services-grid container">
        {services.map((service, i) => (
          <div
            className="service-card"
            key={service.title}
            data-aos="fade-up"
            data-aos-delay={i * 80}
          >
            <div className="service-icon">{service.icon}</div>
            <h4>{service.title}</h4>
            <p>{service.description}</p>
          </div>
        ))}
      </div>

      {/* What Sets Us Apart */}
      <section className="unique-section">
        <h2 className="unique-title" data-aos="fade-up">
          What Sets Us Apart?
        </h2>
        <p className="unique-subtitle" data-aos="fade-up">
          We blend product thinking, performance, and security to ship software that grows with you.
        </p>

        <div className="unique-features">
          <div className="unique-box" data-aos="zoom-in-up">
            <h3>Outcome-Driven</h3>
            <p>Features mapped to measurable business goals and user value.</p>
          </div>
          <div className="unique-box" data-aos="zoom-in-up" data-aos-delay="120">
            <h3>Engineering Excellence</h3>
            <p>Clean architecture, testing discipline, and proactive observability.</p>
          </div>
          <div className="unique-box" data-aos="zoom-in-up" data-aos-delay="240">
            <h3>Secure by Design</h3>
            <p>Threat modeling, secret hygiene, least-privilege access from day one.</p>
          </div>
        </div>

        <h4 className="stack-heading">Tech Stack We Work With</h4>
        <div className="stack-logos">
          {stack.map((t, i) => (
            <span className="stack-tag" key={t.name} style={{ animationDelay: `${i * 0.12}s` }}>
              <span className="stack-ico" aria-hidden>
                {t.icon}
              </span>
              {t.name}
            </span>
          ))}
        </div>
      </section>

      {/* Process Timeline */}
      <section className="timeline-section">
        <div className="container">
          <h2 className="timeline-title" data-aos="fade-up">
            How We Deliver
          </h2>
          <ol className="timeline">
            {timeline.map((step, i) => (
              <li
                className="timeline-item"
                key={step.title}
                data-aos="fade-up"
                data-aos-delay={i * 120}
              >
                <span className="timeline-badge">{step.icon}</span>
                <div className="timeline-content">
                  <h3>{step.title}</h3>
                  <p>{step.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* Industries */}
      <section className="industries-section">
        <h2 className="industries-title" data-aos="fade-up">
          Industries We Serve
        </h2>
        <p className="industries-subtitle" data-aos="fade-up">
          Tailored solutions for domains where reliability, privacy, and scale matter most.
        </p>

        <div className="industries-grid">
          {industries.map((industry, index) => (
            <div
              className="industry-card"
              key={industry}
              data-aos="flip-left"
              data-aos-delay={index * 120}
            >
              {industry}
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <h2 className="cta-title" data-aos="zoom-in">
          Let’s Build Something Great Together
        </h2>
        <p className="cta-subtitle" data-aos="zoom-in" data-aos-delay="100">
          Tell us your goals — we’ll bring the blueprint and the team.
        </p>
        <a
          href="/contact"
          className="cta-button"
          data-aos="zoom-in"
          data-aos-delay="200"
          aria-label="Contact us"
        >
          Contact Us
        </a>
      </section>
    </div>
  );
};

export default Services;
